import { render, staticRenderFns } from "./comp-proyek.vue?vue&type=template&id=7debe43c&"
import script from "./comp-proyek.vue?vue&type=script&lang=js&"
export * from "./comp-proyek.vue?vue&type=script&lang=js&"
import style0 from "./comp-proyek.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports